import { NotFoundPage } from './NotFoundPage'

export function ErrorBoundary() {
  return <NotFoundPage />
}
